import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import Moment from "react-moment";
import useElementOnScreen from "../../Utility/useElementOnScreen";

export default function Task({
  userWorkflowTasksIndex,
  milestoneIndex,
  taskIndex,
  milestone,
  checkboxStatus,
  userWorkflowTasks,
  task,
  completeTask,
  setCheckboxStatus,
  getRoleName,
  getRoleUsers,
  itemsToLoadPerPage,
  setItemsToLoadPerPage,
  itemsLoaded,
  setItemsLoaded,
  user,
}) {
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 1.0
  });

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (isVisible) {
      if (!itemsLoaded.find((item) => item === `${user._id}-${task._id}`)) {
        let newItemsLoaded = [...itemsLoaded];
        newItemsLoaded.push(`${user._id}-${task._id}`);
        setItemsLoaded(newItemsLoaded);
      }
    }
  }, [isVisible]);

  return (
    <Row key={`${userWorkflowTasksIndex}-${milestoneIndex}-${taskIndex}`} className='task-row' style={{ borderBottom: taskIndex === milestone.tasks.length - 1 ? 'none' :  '1px solid #ccc', padding: '20px 0 10px 0' }} ref={containerRef}>
      <Col sm={12}>
        <Row style={{ width: '100%', marginBottom: '20px' }}>
          <Col sm={5}>
            <Form as={Row} style={{ flexWrap: 'nowrap' }}>
              <Form.Control
                className='clickable'
                disabled={checkboxStatus[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`] === true}
                checked={checkboxStatus[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`] === true}
                // checked={isChecked}
                // disabled={isChecked}
                style={{ minWidth: '30px', minHeight: '30px', maxWidth: '30px', maxHeight: '30px', marginRight: '20px', marginTop: '-2px' }}
                type="checkbox"
                name={`task${task._id}Checkbox`}
                onChange={(e) => {
                  let status = {...checkboxStatus};
                  status[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`] = !status[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`];
                  setCheckboxStatus(status);
                  completeTask(userWorkflowTasks.user, task, userWorkflowTasks._id, milestone._id, userWorkflowTasksIndex, milestoneIndex, taskIndex, e.target.checked);
                  // let status = {...checkboxStatus};
                  // status[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`] = !status[`user-${userWorkflowTasks._id}-milestone-${milestone._id}-task-${task._id}`];
                  // setCheckboxStatus(status);
                  // setIsChecked(!isChecked);
                }}
              />
              <Form.Label>{task.name}</Form.Label>
            </Form>
          </Col>
          <Col sm={5}>
            {task.type === 'message' ? '-' : (task.userCanComplete ? 'User' : task.assigneeRoles?.map((role, roleIndex) => {
              return (
                <div key={roleIndex}>
                  {getRoleName(role)}: {getRoleUsers(userWorkflowTasks,role)}
                </div>
              );
            }))}
          </Col>
          <Col sm={2} style={{ textAlign: 'right' }}>
                                                  Due: <Moment format="DD MMM 'YY" add={{ days: task?.endDay - 1 }}>{userWorkflowTasks.startDate}</Moment>
          </Col>
        </Row>
        <Row style={{ width: '100%', marginBottom: task?.taskData?.assets?.length > 0 ? '20px' : '10px' }}>
          <Col sm={5}>
            <div style={{ textAlign: 'justify', paddingLeft: '35px', paddingRight: '20px' }} dangerouslySetInnerHTML={{ __html: task.details }} />
          </Col>
          <Col sm={7}>
            <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: task.instructions }} />
          </Col>
        </Row>
        {task?.taskData?.assets?.length > 0 && (
          <Row style={{ width: '100%', padding: '10px 0 0 0', marginBottom: '10px' }}>
            <Col>
              <div style={{ paddingLeft: '35px' }}>
                {task.taskData.assets.map((upload, uploadIndex) => {
                  return (
                    <span key={uploadIndex} style={{ marginRight: '5px' }}>
                      <a href={upload.path} target='_blank' rel='noreferrer'>
                        {upload.name}
                      </a>
                      {uploadIndex < task.taskData.assets.length - 1 && ', '}
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
}